<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-book title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.audits' | transloco}}</p>
        <p>{{'menu.descriptions.audits' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-end">
            <div class="flex flex-column md:flex-row justify-content-end">
              <button [label]="'common.filters' | transloco" (click)="filtersVisible = !filtersVisible" pButton
                class="p-button-secondary" icon="pi pi-sliders-h"></button>
            </div>
          </div>
        </div>
        <p-table (onLazyLoad)="onPageChange($event)" [(first)]="first" [(rows)]="rows" [lazy]="true" [paginator]="true"
          [responsive]="true" responsiveLayout="stack" breakpoint="1600px" [rowsPerPageOptions]="[10,25,50]"
          [totalRecords]="totalAudits" [value]="audits" sortField="timestamp" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.objectType' | transloco}}</th>
              <th scope="col">{{'attribute.identifier' | transloco}}</th>
              <th scope="col">{{'attribute.attributeName' | transloco}}</th>
              <th scope="col">{{'attribute.newValue' | transloco}}</th>
              <th scope="col">{{'attribute.oldValue' | transloco}}</th>
              <th scope="col">{{'attribute.action' | transloco}}</th>
              <th scope="col">{{'attribute.user' | transloco}}</th>
              <th scope="col">{{'attribute.organization' | transloco}}</th>
              <th scope="col">{{'attribute.auditDate' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template let-audit pTemplate="body">
            <tr *ngIf="!loadingAudits">
              <td>
                <span class="p-column-title bold">{{'attribute.objectType' | transloco}}</span>
                {{ 'audits.objectType.' + audit.objectType | transloco }}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.identifier' | transloco}}</span>
                {{audit.objectId}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.attributeName' | transloco}}</span>
                <ng-container *ngIf="audit.attributeName">
                  {{audit.attributeName}}
                </ng-container>
                <ng-container *ngIf="audit.attributeName && audit.action !== AuditAction.DOWNLOAD && audit.action !== AuditAction.UPLOAD">
                   ({{ 'attribute.' + audit.attributeName | transloco }})
                </ng-container>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.newValue' | transloco}}</span>
                <ng-container *ngIf="audit.action !== AuditAction.DOWNLOAD && audit.action !== AuditAction.UPLOAD">
                  {{this.getAttributeValue(audit.newValue)}}
                </ng-container>
                <ng-container *ngIf="audit.newValue && (audit.action === AuditAction.DOWNLOAD || audit.action === AuditAction.UPLOAD)">
                  {{audit.newValue / 1024 | number:'1.2-2'}} {{'attribute.kb' | transloco}}
                </ng-container>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.oldValue' | transloco}}</span>
                {{this.getAttributeValue(audit.oldValue)}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.action' | transloco}}</span>
                <p-tag *ngIf="audit.action === AuditAction.CREATE" styleClass="create m-0"
                  value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
                <p-tag *ngIf="audit.action === AuditAction.UPDATE" styleClass="update m-0"
                  value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
                <p-tag *ngIf="audit.action === AuditAction.DELETE" styleClass="delete m-0"
                  value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
                <p-tag *ngIf="audit.action === AuditAction.COMMAND" styleClass="command m-0"
                       value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
                <p-tag *ngIf="audit.action === AuditAction.UPLOAD" styleClass="upload m-0"
                       value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
                <p-tag *ngIf="audit.action === AuditAction.DOWNLOAD" styleClass="download m-0"
                       value="{{ 'audits.action.'+ audit.action | transloco | uppercase }}"></p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.user' | transloco}}</span>
                {{audit.username}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
                {{audit.organizationName}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.auditDate' | transloco}}</span>
                {{audit.timestamp | date:'medium': authGuard.getOffset(): this.language }}
              </td>
            </tr>
            <tr *ngIf="loadingAudits">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalAudits == 0" class="flex align-items-center justify-content-between">{{'pagination.empty' |
              transloco}}</div>
            <div *ngIf="totalAudits > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalAudits ? totalAudits : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalAudits}}
              {{(totalAudits > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="objectType">{{'attribute.objectType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [placeholder]="'select.generic' | transloco" [options]="this.auditTypes"
          [(ngModel)]="currentFilters.objectTypes" (keyup.enter)="filtersVisible = false; applyFilters()" class="w-full"
          styleClass="w-full" id="objectType"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="identifier">{{'attribute.identifier' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.objectId" (keyup.enter)="filtersVisible = false; applyFilters()" pInputText
          class="w-full" id="identifier" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="attributeName">{{'attribute.attributeName' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.attributeName" (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText class="w-full" id="attributeName" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="action">{{'attribute.action' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [placeholder]="'select.generic' | transloco" [options]="this.actions"
          [(ngModel)]="currentFilters.actions" (keyup.enter)="filtersVisible = false; applyFilters()" class="w-full"
          styleClass="w-full" id="action"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="user">{{'attribute.user' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.username" (keyup.enter)="filtersVisible = false; applyFilters()" pInputText
          class="w-full" id="user" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
          [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
          [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization"></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="range">{{'attribute.dateRange' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-calendar [(ngModel)]="rangeDates" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
          [yearNavigator]="true" [yearRange]="availableYearRange" [firstDayOfWeek]="1" styleClass="w-full"
          appendTo="body" selectionMode="range" dateFormat="dd/mm/yy" id="range" inputId="range"
          [placeholder]="'select.dateRange' | transloco"></p-calendar>
      </div>
    </div>
    <div class="col-12">
      <p-button [label]="'common.filter' | transloco" [disabled]="!(
            currentFilters.objectTypes ||
            currentFilters.objectId ||
            currentFilters.attributeName ||
            currentFilters.actions ||
            currentFilters.username ||
            organizations ||
            currentFilters.organizationUuids ||
            rangeDates ||
            (currentFilters.from &&
            currentFilters.until)
          )" (onClick)="filtersVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
      </p-button>
      <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>
